<template>

  <div class="main">

    <tk-header-view class="header" :id="tkid"></tk-header-view>

    <v-container fluid class="ma-0 pa-0">
      <v-layout wrap align-center justify-center>
        <viewer
          :options="options"
          :images="profileinfo.pictgrid"
          ref="viewer"
          @inited="inited"
          class="viewer v-viewer-main mt-3 ml-1"
        >
          <template slot-scope="scope">
            <img
              v-for="src in scope.images" :key="src"
              :src="require(`@/img/${src}`)"
              class="pa-1 ma-1 v-viewer-img"
              :width="imgwidth"
              :height="imgheight"
            >
          </template>
        </viewer>
      </v-layout>
    </v-container>

    <!-- Back to top button. Show on mobile/ipad only -->
    <div class="hidden-md-and-up">
      <v-btn
        id="scrolltotop"
        bottom fab fixed right small dark elevation-24
        color="transparent"
        style="color: blue;"
        class="back-to-top"
        slot="activator"
        v-on:click="scrollToTop"
      ><v-icon medium>keyboard_arrow_up</v-icon>
      </v-btn>
    </div>

    <v-container>
      <v-layout class="footer">
        <footer-view></footer-view>
      </v-layout>
    </v-container>

  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import TkHeaderView from "./TkHeaderView";
import FooterView from "./FooterView";
import 'viewerjs/dist/viewer.css'
import Viewer from "v-viewer/src/component.vue"

export default {
  components: {
    TkHeaderView,
    FooterView,
    Viewer
  },
  props: {
    tkid: {
      type: String,
      required: true
    }
  },
  data: () => ({
    options: { "inline": false, "button": true, "navbar": true, "title": true, "toolbar": true, "tooltip": true, "movable": true, "zoomable": true, "rotatable": true, "scalable": true, "transition": true, "fullscreen": true, "keyboard": true, "url": "data-source" },
    imgwidth: '360px',
    imgheight: '340px',
  }),
  methods: {
    inited (viewer) {
      this.$viewer = viewer
    },
    show () {
      this.$viewer.show()
    },
    show () {
      const viewer = this.$el.querySelector('.images').$viewer
      viewer.show()
    },
    scrollToTop() {
      window.scroll({
        top: 0,
        behavior: "smooth"
      });
    },
    handleScroll () {
      if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
        document.getElementById("scrolltotop").style.display = "block";
      } else {
        document.getElementById("scrolltotop").style.display = "none";
      }
      this.scrolled = window.scrollY > 0;
    }
 },
  computed: {
    ...mapGetters([
      'getById'
    ]),
    profileinfo () {
      return this.getById(this.tkid)
    },
  },
  created () {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll);
  }
};

</script>

<style scoped>
.main {
  /* background-image: url("../img/white_wrinkled_silk_blue_1440x1190.jpg"); */
  /* background-color: aliceblue; */
  /* background-color: #f5f5f5; */
  /* background-color: #edf0fd; */
  background-color: #f8f8ff;
  background-repeat: no-repeat;
  background-size: cover;
  max-width: 100%;
  height: 100%;
}
.header {
  text-transform: capitalize;
}
#scrolltotop {
  color: rgba(0, 0, 0, .6);
}
.v-viewer-main {
  margin-left: 20px;
}
.v-viewer-img {
  border-radius: 4px;
  box-shadow: 0 0 10px rgba(0, 0, 0, .7);
 }
.back-to-top {
  /* Not working, so using style on element */
  color: rgba(0, 0, 255, 1);
}
.footer {
  margin-top: 20px
}

@media only screen and (min-device-width: 1081px) {
  .v-viewer-main {
  }
}
@media only screen and (max-device-width: 731px) {
  .v-viewer-main {
    margin-left: 80px;
  }
}
/* iPhone 6, 7, 8 ----------- */
@media only screen and (min-device-width: 375px) and (max-device-height: 667px) and (orientation: portrait) and (-webkit-device-pixel-ratio: 2) {
  .footer {
    margin-top: 80px;
  }
}
/* iPhone 6+, 7+, 8+ ----------- */
@media only screen and (min-device-width: 414px) and (max-device-height: 736px) and (orientation: portrait) and (-webkit-device-pixel-ratio: 2) {
  .footer {
    margin-top: 80px;
  }
}
/* iPhone X ----------- */
@media only screen and (min-device-width: 375px) and (max-device-height: 812px) and (orientation: portrait) and (-webkit-device-pixel-ratio: 3) {
  .footer {
    margin-top: 80px;
  }
}
/* Samsung Galaxy S5 ----------- */
@media only screen and (min-device-width: 360px) and (max-device-height: 640px) and (orientation: portrait) and (-webkit-device-pixel-ratio: 3) {
  .footer {
    margin-top: 80px;
  }
}
/* Samsung Galaxy S3 ----------- */
@media only screen and (min-device-width: 320px) and (max-device-height: 640px) and (orientation: portrait) and (-webkit-device-pixel-ratio: 2) {
  .footer {
    margin-top: 80px;
  }
}
/******** iPads (portrait) *********/
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
.v-viewer-main {
  margin-left: 120px;
}
  .footer {
    margin-top: 40px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TkPictGridView.vue